module.exports = __webpack_public_path__ + "images/bf40e6600057a5b2e2a82f01990a74ee-logo.png";